import React, { memo } from "react";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useCameraContext } from "../context/CameraContext";

const OrientationGuide: React.FC = memo(() => {
  const { state, getCurrentConfig } = useCameraContext();

  if (state.captureMode !== "auto" || !state.showOrientationGuide) {
    return null;
  }

  const { isOrientationCorrect, orientation } = state;
  const currentConfig = getCurrentConfig();
  const indicatorPosition = orientation.beta ? Math.max(10, Math.min(90, Math.abs(orientation.beta) / 2)) : 50;

  return (
    <div className="fixed inset-0 z-40">
      <div className="fixed flex flex-col items-center gap-2 p-2 transform -translate-y-1/2 bg-white rounded-full right-4 top-1/2 bg-opacity-60">
        <div
          className="flex items-center justify-center w-6 h-6 transition-all duration-200 rounded-full"
          style={{
            backgroundColor: isOrientationCorrect ? "#4ab764" : "#d51e3e",
            transform: `translateY(${indicatorPosition}px)`,
          }}
        >
          {isOrientationCorrect ? <CheckOutlined className="text-sm text-white" /> : <CloseOutlined className="text-sm text-white" />}
        </div>

        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className={`w-4 h-4 rounded-full opacity-50 ${i === 3 ? "bg-green-500" : "bg-red-500"}`} />
        ))}
      </div>
    </div>
  );
});

OrientationGuide.displayName = "OrientationGuide";

export default OrientationGuide;
